import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const MarlboroLoadable = Loadable({
    loader: (): any => import('./Marlboro').then((res) => res.Marlboro),
    loading: <Loader/>,
});
